import { useQueryClient } from '@tanstack/vue-query'
import { resetNotices } from '~/composables/useNotices'

const AUTH_QUERY_ROOTS = new Set(['wallet', 'promo', 'games'])

/** 退出 / 401 后清掉登录态相关的 Vue Query 缓存与站内信列表 */
export default defineNuxtPlugin({
  name: 'session-query-cache',
  dependsOn: ['wagmi'],
  setup() {
    const userStore = useUserStore()
    const queryClient = useQueryClient()

    watch(
      () => userStore.isLoggedIn,
      (loggedIn, wasLoggedIn) => {
        if (!wasLoggedIn || loggedIn) return
        resetNotices()
        queryClient.removeQueries({
          predicate: ({ queryKey }) => AUTH_QUERY_ROOTS.has(String(queryKey[0])),
        })
      },
    )
  },
})
